<template>
  <el-table-column
    prop="is_customer_contact"
    sortable
    label="Vevői"
    width="80"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.is_customer_contact" size="small" type="success">
        Igen
      </el-tag>
      <el-tag v-else type="danger" size="small">
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_customer_contact',
  };
</script>
